import { getOne } from "../../../helper/baseFetch";
import { constants } from '../../../Constants/constants';
import { getScDisabled } from "../../../helper/util";

const IMAGE_LANGUAGE_KEY_MAP = {
  EN: 'en',
  en: 'en',
  ZH_CN: 'zh-CN',
  'zh-CN': 'zh-CN',
  zh_CN: 'zh-CN',
  ZH_HK: 'zh-HK',
  'zh-HK': 'zh-HK',
  zh_HK: 'zh-HK',
  ZH_TW: 'zh-TW',
  'zh-TW': 'zh-TW',
  zh_TW: 'zh-TW',
};

const normalizeImageLanguageKey = (languageKey) => IMAGE_LANGUAGE_KEY_MAP[languageKey] || languageKey;

const looksLikeLanguageMap = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  if (value.cosFileKey || value.cosFileUrl) {
    return false;
  }

  const keys = Object.keys(value);
  return keys.length > 0 && keys.every((key) => !!IMAGE_LANGUAGE_KEY_MAP[key]);
};

const normalizeImageMedia = (imageMedia) => {
  if (!imageMedia || typeof imageMedia !== 'object' || Array.isArray(imageMedia)) {
    return imageMedia;
  }

  return Object.entries(imageMedia).reduce((normalizedImageMedia, [mediaKey, mediaValue]) => {
    if (looksLikeLanguageMap(mediaValue)) {
      normalizedImageMedia[mediaKey] = Object.entries(mediaValue).reduce((normalizedMediaValue, [languageKey, imageData]) => {
        normalizedMediaValue[normalizeImageLanguageKey(languageKey)] = imageData;
        return normalizedMediaValue;
      }, {});
    } else {
      normalizedImageMedia[mediaKey] = mediaValue;
    }

    return normalizedImageMedia;
  }, {});
};

export const getProduct = (productCode, store) => {
  return new Promise((resolve, reject) => {
    getOne(constants.PATH.PRODUCT.PRODUCT + "/" + productCode, undefined, (payload) => {
      payload.imageMedia = normalizeImageMedia(payload.imageMedia);
      if (payload.cashCouponMedia) {
        payload.cashCouponMedia = normalizeImageMedia(payload.cashCouponMedia);
      }

      payload.scNameDisable = getScDisabled(payload.tcName, payload.scName);
      payload.scDescriptionDisable = getScDisabled(payload.tcDescription, payload.scDescription);
      payload.scTacDisable = getScDisabled(payload.tcTac, payload.scTac);
      payload.scRedeemDescriptionDisable = getScDisabled(payload.tcRedeemDescription, payload.scRedeemDescription);
      payload.scDiscountDescriptionDisable = getScDisabled(payload.tcDiscountDescription, payload.scDiscountDescription);

      if (payload.attributeList && payload.attributeList.length > 0) {
        payload.attributeList.map((attribute, attributeIndex) => {
          if (attribute.optionList && attribute.optionList.length > 0) {
            attribute.optionList.map((optionItem, optionIndex) => {
              optionItem.scValueDisable = getScDisabled(optionItem.tcValue, optionItem.scValue);
              return optionItem;
            })
          }
          return attribute;
        })
      }

      resolve(payload);
    }, undefined, store);
  })
}